import { useTranslation } from 'react-i18next';
import './DisconnectAppPage.css';

const DisconnectAppButton = () => {
  const { t } = useTranslation();

  return (
    <a
      href="electric-desktop://disconnect-device"
      id="open-desktop-app-disconnect">
      {t('disconnect.openButton')}
    </a>
  );
};

const DisconnectAppPage = () => {
  const { t } = useTranslation();

  return (
    <main className="page-container">
      <img
        className="logo"
        alt={t('common.electricLogo')}
        src="/assets/images/logo_electric_white.png"
      />
      <section className="disconnect-app-content">
        <div>
          <h1 className="disconnect-app-h1 disconnect-app-text">
            {t('disconnect.title')}
          </h1>
          <div className="numbered-steps-wrapper">
            <div>
              <div>
                <div className="num-circle">1</div>
              </div>
              <p className="disconnect-app-text">{t('disconnect.step1')}</p>
            </div>
            <div>
              <div>
                <div className="num-circle">2</div>
              </div>
              <p className="disconnect-app-text">{t('disconnect.step2')}</p>
            </div>
            <div>
              <div>
                <div className="num-circle">3</div>
              </div>
              <p className="disconnect-app-text">{t('disconnect.step3')}</p>
            </div>
          </div>
          <p className="disconnect-app-text small">
            {t('disconnect.supportText')}{' '}
            <a href="mailto:product-support@electric.ai">
              product-support@electric.ai
            </a>
          </p>
          <div className="disconnect-app-button">
            <DisconnectAppButton />
          </div>
        </div>
        <div>
          <img
            src="/assets/images/laptop-app-features.png"
            alt={t('common.laptopWithIcons')}
            width="600px"
          />
        </div>
      </section>
    </main>
  );
};

export default DisconnectAppPage;
